/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { Box } from '@towersystems/towersystems-design-system';
import { map, size } from 'lodash';
import { Table } from 'antd';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import DropdownLink from 'components/dropdown-link';
import ResourceDataPopover from './resource-data-popover';
import Tag from 'components/tag';
import DateTime from 'components/date-time';

/**
 * Style dependencies
 */
import './styles.scss';

const ResourceListTable = ({ isRequesting, resources, ...props }) => {
    const [activeResource, setActiveResource] = useState(null);
    const [activeResourcePopoverOpen, setActiveResourcePopoverOpen] = useState(false);
    useEffect(() => {}, [resources]);

    const dataSource = map(resources, (r) => {
        return r;
    });

    const columns = [
        {
            title: 'Type',
            key: 'type',
            dataIndex: 'type',
            render: (type) => {
                return type ? <Tag>{type}</Tag> : '-';
            },
        },
        {
            title: 'Retailer Identifier',
            key: 'identifier',
            dataIndex: 'identifier',
        },
        {
            title: 'Connections',
            key: 'connects',
            dataIndex: 'connects',
            render: (connects) => {
                return size(connects);
            },
        },
        {
            title: 'Last Updated',
            key: 'updated_at',
            dataIndex: 'updated_at',
            render: (updatedAt) => {
                return <DateTime date={updatedAt} format='Do MMM, YYYY HH:mm:ss' />;
            },
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (a) => {
                return (
                    <DropdownLink
                        title='Actions'
                        items={[
                            {
                                label: 'View data',
                                key: 'view_data',
                                onClick: () => {
                                    setActiveResource(a);
                                    setActiveResourcePopoverOpen(true);
                                },
                            }, 
                        ]}
                    />
                );
            },
        },
    ];

    return (
        <Box>
            <Table
                columns={columns}
                dataSource={dataSource}
                pagination={false}
                loading={isRequesting}
                scroll={{ x: 'max-content' }}
            />
            <ResourceDataPopover
                resource={activeResource}
                isOpen={activeResourcePopoverOpen}
                close={() => setActiveResourcePopoverOpen(false)}
            />
        </Box>
    );
};

export default connect(null, {})(ResourceListTable);
